import { Star, Quote, Users } from 'lucide-react';

// Actual reviews from Udemy - The Ultimate 30-Day Beginner DJ Course by Blendonics
const REVIEWS = [
  {
    id: 1,
    name: 'Athena',
    rating: 5,
    date: '1 month ago',
    verified: true,
    comment: "I've just started this DJ Course and I'm already blown away by how clear the lessons are. The explanations are simple, the interactive quizzes are good and the pace is perfect for someone just starting out! I'm excited to keep going!"
  },
  {
    id: 2,
    name: 'Udemy User',
    rating: 5,
    date: '2 months ago',
    verified: true,
    comment: 'Very helpful'
  },
  {
    id: 3,
    name: 'Michael',
    rating: 5,
    date: '3 months ago',
    verified: true,
    comment: 'Great course and learnt more than I thought I would! Thank you!'
  },
  {
    id: 4,
    name: 'Curtis',
    rating: 5,
    date: '8 months ago',
    verified: true,
    comment: "I'm learning how to DJ with this course and I've learned so much already. I'd definitely recommend!"
  },
  {
    id: 5,
    name: 'Jade',
    rating: 5,
    date: '2 weeks ago',
    verified: true,
    comment: "I work full-time and still kept up. The lessons fit around my full-time job, they were short, focused, and easy to follow."
  },
  {
    id: 6,
    name: 'Marcus',
    rating: 5,
    date: '1 month ago',
    verified: true,
    comment: "I almost didn't join because I didn't have decks. I started with just my laptop and bought a cheap pair a month later, it was worth it!"
  },
  {
    id: 7,
    name: 'Aaron',
    rating: 5,
    date: '3 weeks ago',
    verified: true,
    comment: "I thought the course would be too advanced, but it's perfect for beginners like me."
  },
];

const Reviews = () => {
  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, i) => (
      <Star
        key={i}
        size={18}
        fill={i < rating ? '#D4AF37' : 'transparent'}
        stroke={i < rating ? '#D4AF37' : '#666'}
      />
    ));
  };

  return (
    <div className="min-h-screen py-24" data-testid="reviews-page">
      <div className="container mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-16">
          <h1 className="text-4xl sm:text-5xl font-bold mb-4" style={{ color: '#ffffff' }}>
            Reviews and Testimonials
          </h1>
          <p className="text-lg max-w-2xl mx-auto mb-8" style={{ color: '#a3a3a3' }}>
            Real feedback from DJs taking The Ultimate 30-Day Beginner DJ Course by Blendonics
          </p>
          
          {/* Rating Summary */}
          <div className="inline-flex items-center gap-6 glass-panel rounded-2xl px-8 py-6 border">
            <div className="text-center">
              <div className="text-5xl font-bold" style={{ color: '#D4AF37' }}>5.0</div>
              <div className="flex justify-center mt-2">
                {renderStars(5)}
              </div>
              <p className="text-xs mt-1" style={{ color: '#a3a3a3' }}>Course Rating</p>
            </div>
            <div className="h-16 w-px bg-border"></div>
            <div className="text-center">
              <div className="flex items-center gap-2 justify-center">
                <Users size={24} style={{ color: '#D4AF37' }} />
                <span className="text-3xl font-bold" style={{ color: '#D4AF37' }}>100+</span>
              </div>
              <p className="text-sm mt-1" style={{ color: '#a3a3a3' }}>enrolled so far and counting</p>
            </div>
          </div>
        </div>

        {/* Reviews */}
        <div className="max-w-3xl mx-auto">
          <h3 className="text-2xl font-bold mb-6 text-center" style={{ color: '#ffffff' }}>
            What Our DJs Are Saying
          </h3>
          
          <div className="space-y-6">
            {REVIEWS.map((review) => (
              <div
                key={review.id}
                className="glass-panel rounded-2xl p-6 border hover:border-[#D4AF37]/30 transition-colors"
                data-testid={`review-${review.id}`}
              >
                <div className="flex items-start gap-4">
                  <div className="flex-shrink-0 w-12 h-12 rounded-full flex items-center justify-center text-xl font-bold" style={{ background: 'rgba(212, 175, 55, 0.1)', color: '#D4AF37' }}>
                    {review.name.charAt(0)}
                  </div>
                  <div className="flex-1">
                    <div className="flex items-center justify-between mb-2 flex-wrap gap-2">
                      <div className="flex items-center gap-2">
                        <h4 className="font-bold" style={{ color: '#ffffff' }}>{review.name}</h4>
                        {review.verified && (
                          <span className="text-xs px-2 py-0.5 rounded-full" style={{ background: 'rgba(34, 197, 94, 0.1)', color: '#22c55e' }}>
                            ✓ Verified
                          </span>
                        )}
                      </div>
                      <span className="text-xs" style={{ color: '#666' }}>{review.date}</span>
                    </div>
                    <div className="flex items-center gap-1 mb-3">
                      {renderStars(review.rating)}
                    </div>
                    <div className="relative">
                      <Quote size={20} className="absolute -left-1 -top-1 opacity-20" style={{ color: '#D4AF37' }} />
                      <p className="text-sm leading-relaxed pl-4" style={{ color: '#a3a3a3' }}>
                        {review.comment}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* CTA Section */}
        <div className="text-center mt-16">
          <div className="glass-panel rounded-2xl p-8 border inline-block">
            <h3 className="text-2xl font-bold mb-4" style={{ color: '#ffffff' }}>
              Ready to Start Your DJ Journey?
            </h3>
            <p className="mb-6" style={{ color: '#a3a3a3' }}>
              Join the Global Community of DJs learning with Blendonics
            </p>
            <a href="/pricing">
              <button className="px-8 py-3 rounded-full font-semibold text-lg transition-all" style={{ background: '#D4AF37', color: '#141414' }}>
                Get Started Today
              </button>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Reviews;
